module.exports = __webpack_public_path__ + "static/image/service/ceo.ver2_0_2.jpg?f0f28a30";